<app-scroll-spy-menu></app-scroll-spy-menu>

<app-default-card
  [title]="'Inbetriebnahme'"
  [info]="'Bitte überprüfen Sie die hier angegebenen Informationen'"
  [showThisComponent]="true"
  [showChildComponent]="commissioningRequestDto">
  <app-company-location-summary
    [companyLocation]="commissioningRequestDto?.companyLocation"></app-company-location-summary>
  <app-connection-object-summary
    [connectionObject]="commissioningRequestDto?.connectionObject"
    [connectionObjectAdditionalInfo]="
      commissioningRequestDto?.connectionObjectAdditionalInfo
    "></app-connection-object-summary>
  <app-filiation-data-summary
    [contactData]="commissioningRequestDto?.customer"
    [title]="'Anschlussnehmer (Eigentümer)'"></app-filiation-data-summary>
  <app-filiation-data-summary
    [contactData]="commissioningRequestDto?.invoiceContact"
    [title]="'Abweichender Anschlussnutzer'"></app-filiation-data-summary>
</app-default-card>
<app-default-card
  [title]="'Technischen Daten'"
  [info]="'Technischen Daten.'"
  [showThisComponent]="true"
  [showChildComponent]="commissioningRequestDto">
  <section *ngIf="commissioningRequestDto?.actions">
    <app-gas-action-summary [actions]="commissioningRequestDto.actions"></app-gas-action-summary>
  </section>
</app-default-card>

<app-default-card
  *ngIf="showUploads"
  [title]="'Dokumente'"
  [info]="'Dokumente.'"
  [showThisComponent]="commissioningRequestDto?.uploads && commissioningRequestDto?.uploads.length > 0"
  [showChildComponent]="commissioningRequestDto">
  <section>
    <app-documents-upload-summary [uploads]="commissioningRequestDto?.uploads"></app-documents-upload-summary>
  </section>
</app-default-card>

<app-cr-chimneysweep-confirmation-form
  #form
  (onErrorsChanged)="onFormErrorsChanged($event)"></app-cr-chimneysweep-confirmation-form>
<app-default-card [title]="title" [info]="''" [showChildComponent]="true" [showThisComponent]="true">
  <app-form-confirmation
    [actions]="actions"
    [actionConfirm]="'ChimneySweepAccepted'"
    [textConfirm]="'Bestätigen'"
    [actionReject]="'ChimneySweepRejected'"
    [message]="'Sind Sie sicher, dass Sie die Daten zur Inbetriebsetzung bestätigen wollen?'"
    [errorFormList]="errorFormList"
    (onActionClickedEvent)="actionToRun($event)"></app-form-confirmation>
</app-default-card>
